import * as Types from '../constants/Types';

export const getRecommendationAction = (params) => ({type: Types.GET_RECOMMENDATION_ACTION, params});
export const setRecommendationAction = (recommend) => ({ type: Types.GET_RECOMMENDATION_SUCCESS, recommend });
